import {
  CreatePlaceRequest,
  GetPlacesByBoundingBoxRequest,
  SearchPlacesByKeywordRequest,
  UpdatePlaceMetadataRequest,
} from './requests/place-request.ts';
import { apiClient } from './client.tsx';
import {
  CreatePlaceResponse,
  GetPlaceByIdResponse,
  GetPlacesByBoundingBoxResponse,
  PendPlaceResponse,
  PublishPlaceResponse,
  SearchPlacesByKeywordResponse,
  UnpublishPlaceResponse,
  UpdatePlaceMetadataResponse,
} from './responses/place-response.ts';

export const createPlace = (request: CreatePlaceRequest) =>
  apiClient
    .post<CreatePlaceResponse>('/v2/places', request)
    .then((res) => res.data.data);

export const updatePlaceMetadata = (request: UpdatePlaceMetadataRequest) =>
  apiClient
    .put<UpdatePlaceMetadataResponse>(`/v2/places/${request.placeId}`, request)
    .then((res) => res.data.data);

export const getPlaceById = (placeId: string) =>
  apiClient
    .get<GetPlaceByIdResponse>(`/v2/places/${placeId}`)
    .then((res) => res.data.data);

export const getPlacesByBoundingBox = (query: GetPlacesByBoundingBoxRequest) =>
  apiClient
    .get<GetPlacesByBoundingBoxResponse>('/v2/places', { params: query })
    .then((res) => res.data.data);

export const searchPlacesByKeyword = (query: SearchPlacesByKeywordRequest) =>
  apiClient
    .get<SearchPlacesByKeywordResponse>('/v2/places/search', { params: query })
    .then((res) => res.data.data);

export const publishPlace = (placeId: string) =>
  apiClient
    .post<PublishPlaceResponse>(`/v2/places/${placeId}/publish`)
    .then((res) => res.data.data);

export const pendPlace = (placeId: string) =>
  apiClient
    .post<PendPlaceResponse>(`/v2/places/${placeId}/pend`)
    .then((res) => res.data.data);

export const unpublishPlace = (placeId: string) =>
  apiClient
    .post<UnpublishPlaceResponse>(`/v2/places/${placeId}/unpublish`)
    .then((res) => res.data.data);

export const removePlace = (placeId: string) =>
  apiClient.delete(`/v2/places/${placeId}`);
